import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const catColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function ArticleTeaserSection() {
  return (
    <section className="relative py-16 md:py-20 lg:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              Zasoby
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
              Najnowsze artykuły i poradniki
            </h2>
            <p className="text-foreground-500 mt-2 text-sm md:text-base max-w-lg">
              Kompleksowe przewodniki, recenzje i porady dotyczące USFans Spreadsheet — wszystko w jednym miejscu.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${catColorMap[article.categoryColor] || catColorMap.primary}`}>
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{new Date(article.date).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                </div>
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 text-sm md:text-base leading-snug flex-1">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm mt-2 line-clamp-2">
                  {article.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/usfans-spreadsheet-kompletny-przewodnik"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Zobacz wszystkie artykuły
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}